import http from './http-common';

class FabricContractDeliveryScheduleService {


    get(id) {
      return http.get(`/fabriccontract/deliveryschedule/${id}`);
    }
    update(id, data) {
      return http.put(`/fabriccontract/deliveryschedule/${id}`, data);
    }
    insert(data) {
      return http.post(`/fabriccontract/deliveryschedule/add`,data);
    }

  //   delete(type, id) {
  //     return http.delete(`/fabriccontract/${type}/${id}`);
  //   }

  //   getDeliverySchedule(id) {
  //     return http.get(`/fabriccontractdeliveryschedule/${id}`);
  //   }

  

}

export default new FabricContractDeliveryScheduleService();
